import React, { useEffect } from "react";
import { t } from "i18next";

function Toast({ isVisible, setIsVisible }) {
  useEffect(() => {
    if (isVisible) {
      setIsVisible(true);

      const timer = setTimeout(() => setIsVisible(false), 5000);

      return () => clearTimeout(timer);
    }
  }, [isVisible]);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="hayley-mx-auto hayley-my-[2px] hayley-flex hayley-w-full hayley-max-w-md hayley-items-center hayley-justify-between hayley-bg-[#EDB526] hayley-p-2 hayley-text-white md:hayley-py-3 md:hayley-pl-4 md:hayley-pr-3">
      <span className="hayley-text-sm hayley-font-semibold ">{t("noMatchingUnitWightFilters")}</span>
      <button
        onClick={() => setIsVisible(false)}
        className="hayley-ml-3 hayley-h-6 hayley-cursor-pointer hayley-border-none hayley-bg-transparent hayley-text-lg hayley-font-bold hayley-text-white"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.8346 6.16602L6.16797 17.8327" stroke="white" strokeMiterlimit="10" strokeLinecap="square" />
          <path d="M17.8346 17.8327L6.16797 6.16602" stroke="white" strokeMiterlimit="10" strokeLinecap="square" />
        </svg>
      </button>
    </div>
  );
}

export default Toast;
